import React from "react";
import { Progress } from "antd";
function Survey({data}) {
  return (
    <div className="flex flex-col bg-white font-body w-3/4 p-6 rounded-xl gap-6 whitespace-nowrap max-lg:w-full  ">
      <div className="flex flex-row text-right ">
        <h2 className="text-[#005AC7] text-2xl font-bold  w-1/2 whitespace-nowrap max-lg:text-[0.875rem]">
          کارشناس از نگاه کشاورزان
        </h2>
      
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex flex-row max-lg:gap-5 justify-evenly">
          <label className="w-1/4 text-right text-sm">نحوه پاسخگویی</label>
          <Progress
            className="font-body w-3/5"
            size={["", 15]}
            status="active"
            percent={Math.ceil(data?.responsivenessAvg)}
            strokeColor={{ "0%": "#215697", "100%": " #3089F6" }}
          />
        </div>
        <div className="flex flex-row max-lg:gap-5 justify-evenly">
          <label className="w-1/4 text-right text-sm">اطلاعات علمی</label>
          <Progress
            size={["", 15]}
            className="font-body w-3/5"
            status="active"
            percent={Math.ceil(data?.scientificInformationAvg)}
            strokeColor={{ "0%": "#215697", "100%": " #3089F6" }}
          />
        </div>
        <div className="flex flex-row text-right max-lg:gap-5 justify-evenly">
          <label className="w-1/4 text-sm">مهارت اجرایی</label>
          <Progress
            status="active"
            size={["", 15]}
            className="font-body w-3/5"
            percent={Math.ceil(data?.executiveSkillsAvg)}
            strokeColor={{ "0%": "#215697", "100%": " #3089F6" }}
          />
        </div>
        <div className="flex flex-row text-right max-lg:gap-5 justify-evenly">
          <label className="w-1/4 text-sm">پیگیری و پشتیبانی</label>
          <Progress
            status="active"
            size={["", 15]}
            className="font-body w-3/5"
            percent={Math.ceil(data?.supportAvg)}
            strokeColor={{ "0%": "#215697", "100%": " #3089F6" }}
          />
        </div>
        <div className="flex flex-row text-right max-lg:gap-5 justify-evenly">
          <label className="w-1/4 text-sm">محتوای آموزشی</label>
          <Progress
            status="active"
            size={["", 15]}
            className="font-body w-3/5"
            percent={Math.ceil(data?.educationalContentAvg)}
            strokeColor={{ "0%": "#215697", "100%": " #3089F6" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Survey;
